"use client";
import { useState } from "react";
import { useRouter } from "next/navigation";
import { trackEvent } from "@/lib/gtag";

// /programs 목록 카드의 '관심공고 등록'(북마크) 버튼. 카드 전체가 <Link> 라 클릭 전파를 막는다.
export default function SaveProgramButton({ docId, initialSaved, loggedIn, inline = false }: { docId: number; initialSaved: boolean; loggedIn: boolean; inline?: boolean }) {
  const router = useRouter();
  const [saved, setSaved] = useState(initialSaved);
  const [busy, setBusy] = useState(false);

  async function toggle(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    if (!loggedIn) {
      router.push(("/login?callbackUrl=" + encodeURIComponent(location.pathname + location.search)) as never);
      return;
    }
    if (busy) return;
    setBusy(true);
    const prev = saved;
    setSaved(!prev); // 낙관적 업데이트
    try {
      const res = await fetch("/api/my/saved", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ docId }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && typeof data.saved === "boolean") {
        setSaved(data.saved);
        if (data.saved) trackEvent("save_program", { item_id: docId }); // 전환: 관심공고 저장
      } else setSaved(prev); // 실패 시 롤백
    } catch {
      setSaved(prev);
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      onClick={toggle}
      disabled={busy}
      title={saved ? "관심공고 해제" : "관심공고 등록"}
      aria-pressed={saved}
      style={{
        // inline: 헤더 등 흐름 배치 / 기본: 카드 우상단 오버레이(absolute).
        ...(inline ? {} : { position: "absolute", top: 12, right: 12, zIndex: 2 }),
        flexShrink: 0,
        width: inline ? 40 : 34, height: inline ? 40 : 34, borderRadius: inline ? 999 : 9, cursor: busy ? "default" : "pointer",
        display: "flex", alignItems: "center", justifyContent: "center",
        border: saved ? "none" : "1px solid #C7D3FF",
        background: saved ? "#2C5CFF" : "#fff",
        color: saved ? "#fff" : "#2C5CFF",
      }}
    >
      <span style={{ fontFamily: "'Material Symbols Outlined'", fontSize: 20, lineHeight: 1, fontVariationSettings: saved ? "'FILL' 1" : undefined }}>
        bookmark
      </span>
    </button>
  );
}
